import PropTypes from 'prop-types';
import React from 'react';
import he from 'he';
import { useIntl, FormattedMessage } from 'react-intl';

import { stripTags } from '@bibliocommons/utils-html';

function FormattedHTMLMessage({ id, tagName: Tag = 'span', values = {}, defaultMessage }) {
  const intl = useIntl();
  const message = intl.messages?.[id] || defaultMessage || id;

  // Use FormattedMessage if the message does not contain html tags or html entities
  const noHtmlTags = stripTags(message) === message;
  const noHtmlEntities = he.decode(message) === message;
  if (noHtmlTags && noHtmlEntities) {
    return <FormattedMessage id={id} tagName={Tag} values={values} defaultMessage={defaultMessage} />;
  }

  // Simply replace placeholders in the message with corresponding values.
  // Note that advanced formatting syntax (select, plural, etc) is not supported.
  // eg. Input: "The <strong>{floorname}</strong>", Output: "The <strong>1st Floor</strong> at <strong>"
  const formattted = message.replace(/\{(\w+)\}/g, function formatter(_, placeholder) {
    return values[placeholder] || placeholder;
  });

  return <Tag id={id} dangerouslySetInnerHTML={{ __html: formattted }} />;
}

FormattedHTMLMessage.propTypes = {
  id: PropTypes.string.isRequired,
  tagName: PropTypes.string,
  values: PropTypes.object,
  defaultMessage: PropTypes.string
};

export default FormattedHTMLMessage;
